function Services() {
  return (
    <div className="services container">
      <h1 style={{ paddingBottom: "100px", paddingTop: "100px" }}>
        This is Services.
      </h1>
    </div>
  );
}

export default Services;
